// Library Class
import * as $ from 'jquery';
import { DatePipe } from '@angular/common';
import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, HostListener } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Subscription } from 'rxjs';
// Class
import { MasterConstants } from '../../../common/constants/master-constants';
import { FilterOption } from '../../../common/components/filter/filter-model';
import { ControlType } from '../../../common/components/filter/filter-enum';
import { CommonService } from './../../../services/common/common.service';
import { LocalStorageService } from '../../../services/infrastructure/local-storage.service';
// Service Class
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { CppCoiRequestService } from '../../../services/cpp-coi-request/cpp-coi-request.service';
import { ExcelService } from './../../../services/infrastructure/excel.service';
import { OTIOrderLandingFilterVM } from '../../../models/OTI/OTIOrderLandingFilterVM';
import { OtiService } from '../../../services/oti/oti.service';
// Model Class
import { COILandingFilterVM } from '../../../models/COI/COILandingFilterVM';
import { Router } from '@angular/router';
import { ConfirmDialogComponent } from '../../../common/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-cpp-coi-landing',
  templateUrl: './cpp-coi-landing.component.html',
  styleUrls: ['./cpp-coi-landing.component.scss']
})
export class CppCoiLandingComponent implements OnInit, OnDestroy, AfterViewInit {
  headerCompany = MasterConstants.US_COMPANYCODE;
  validateEvolveData: any;
  readOnlyAccess = false;
  filterOptionsData: Array<FilterOption>;
  subscription = new Subscription();
  bannerMessage = '';
  selectedTabIndex = 0;
  filters: OTIOrderLandingFilterVM = new OTIOrderLandingFilterVM();
  masterConstants = MasterConstants;
  draftCoiDataSource: MatTableDataSource<any>;
  coiDataSource: MatTableDataSource<any>;
  @ViewChild('coiPaginator', { read: MatPaginator }) coiPaginator: MatPaginator;
  @ViewChild('coiTable', { read: MatSort }) coiSort: MatSort;
  @ViewChild('draftCoiPaginator', { read: MatPaginator }) draftCoiPaginator: MatPaginator;
  @ViewChild('draftCoiTable', { read: MatSort }) draftCoiSort: MatSort;
  coiColumns: string[] = [];
  draftCoiColumns: string[] = [];
  filter: COILandingFilterVM = new COILandingFilterVM();
  coiDataList: any = [];
  draftCoiDataList: any = [];
  tabNode = false;
  isSubscriptionAccess = true;
  data: any;

  constructor(
    private loaderService: LoaderService,
    private localStorageService: LocalStorageService,
    private cppCoiRequestService: CppCoiRequestService,
    private matDialog: MatDialog,
    private toastrService: ToastrService,
    public excelService: ExcelService,
    private router: Router,
    private datePipe: DatePipe,
    private commonService: CommonService,
    private otiService: OtiService) { }

  // ngOnInit
  ngOnInit() {

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      this.validateEvolveData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (this.validateEvolveData !== null && this.validateEvolveData !== undefined && this.validateEvolveData.resultData.length > 0) {
        // Set Subscription Access
        const isActiveUser = this.validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
        if (!isActiveUser.isSubscriptionAccess) {
          this.isSubscriptionAccess = false;
        } else {
          this.isSubscriptionAccess = true;
        }
      }

      this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.COI_ORDER);
    }

    this.getBannerMessage();
    this.getGridData();
    this.setFilterAndGridColumn();
    this.setDefaultFilter();
    this.setDropDownValues();
  }

  // Get Banner Message
  getBannerMessage() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.cppCoiRequestService.getLandingBannerMessage().subscribe((result: any) => {
      this.bannerMessage = result.message;
      this.loaderService.setLoaderStatus(false);
    }, error => {
      this.loaderService.setLoaderStatus(false);
    }));
  }

  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccSummaryTableHeight();
  }

  // Tab changed
  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    this.selectedTabIndex = tabChangeEvent.index;
    this.setAccSummaryTableHeight();
  };

  // set account table height
  setAccSummaryTableHeight() {
    setTimeout(function () {
      const templateHeight = window.innerHeight - $('.TopSec').outerHeight() - $('.form-sec').outerHeight() - $('.mat-tab-header').outerHeight() - $('.fulfill-top-sec').outerHeight() - 200;
      $('.activeReturnRequest').css('max-height', templateHeight + 'px');
      $('.draftReturnRequest').css('max-height', templateHeight + 'px');
    }, 100);
  }

  // Set Filter and Grid Columns
  setFilterAndGridColumn() {
    this.filterOptionsData = [
      { label: 'Request Id', key: 'requestId', controlType: ControlType.Text },
      { label: 'Customer PO', key: 'customerPO', controlType: ControlType.Text },
      { label: 'Account Name', key: 'accountName', controlType: ControlType.Text },
      { label: 'Account Number', key: 'accountNumber', controlType: ControlType.Text },
      { label: 'Request Date', key: 'requestDate', controlType: ControlType.DateRange },
      { label: 'Status', key: 'status', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'value' },
    ];

    this.coiColumns = ['requestId', 'custPONumber', 'accountName', 'accountNumber', 'requestDate', 'status', 'viewOrder'];
    this.draftCoiColumns = ['requestId', 'custPONumber', 'accountName', 'accountNumber', 'draftDate', 'status', 'deleteRequest'];
  }

  // Set Drop down values for filter
  setDropDownValues() {
    if (MasterConstants.CPP_COI_STATUS_LIST) {
      this.filterOptionsData.find(x => x.key == 'status').controlData = MasterConstants.CPP_COI_STATUS_LIST;
    }
  }

  // Set default filter values
  setDefaultFilter() {
    this.filter = {
      requestId: null,
      customerPO: null,
      accountName: null,
      accountNumber: null,
      requestDate: null,
      status: null
    };
  }

  // Redirect new Create New Request
  createNewRequest() {
    this.router.navigate(['/cpp/cpp-coi-request-entry/']);
  }

  // ngOnDestroy
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  getGridData() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.cppCoiRequestService.getLandingGridData(this.filter).subscribe((result: any[]) => {
      // Active tab variables.
      this.coiDataList = result.filter(x => x.status !== 'DRAFT');
      this.coiDataSource = new MatTableDataSource(this.coiDataList);
      this.coiDataSource.paginator = this.coiPaginator;
      this.coiDataSource.paginator.firstPage();
      this.coiDataSource.sort = this.coiSort;

      // Draft tab variables.
      this.draftCoiDataList = result.filter(x => x.status === 'DRAFT');
      this.draftCoiDataSource = new MatTableDataSource(this.draftCoiDataList);
      this.draftCoiDataSource.paginator = this.draftCoiPaginator;
      this.draftCoiDataSource.paginator.firstPage();
      this.draftCoiDataSource.sort = this.draftCoiSort;

      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

  // Search Action
  filterSearchClick(event) {
    this.filter = event;
    this.getGridData();
  }

  // Clear All Action
  filterClearAllClick(event) {
    this.filter = event;
    this.getGridData();
  }

  // Navigate to selected COI request detail
  navigateCoiRequestDetail(obj: any, tabType: string) {
    this.loaderService.setLoaderStatus(true);
    this.cppCoiRequestService.setCoiOrderIdCPP(obj.requestId);
    this.router.navigate(['/cpp/cpp-coi-request-entry']);
    this.loaderService.setLoaderStatus(false);
  }

  // Delete draft request
  deletecoidraftrequest(coiOrder: any) {
    if (coiOrder) {
      const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '400px',
        data: { title: 'Delete Draft Request', message: 'Do you want to delete this saved request?', labelYes: 'Yes', labelNo: 'No', dialogType: 'confirm' }
      });
      this.subscription.add(dialogRef.afterClosed().subscribe(result => {
        // If user selected Yes
        if (result == true) {
          this.loaderService.setLoaderStatus(true);
          this.subscription.add(this.cppCoiRequestService.deleteDraftRequest(coiOrder.requestId).subscribe(result => {
            if (result) {
              this.toastrService.success('Draft order deleted successfully.');
              this.getGridData();
            }
            this.loaderService.setLoaderStatus(false);
          }, error => this.loaderService.setLoaderStatus(false)));
        }
      }));
    }
  }

  viewOrderDetail(obj: any, isSplitView: boolean, tab: string) {
    if (isSplitView) {
      this.cppCoiRequestService.webOrderNumberAndSplitId = obj.coiorderNumber + '~' + obj.splitId + '~' + tab + '~CPPLanding';
    } else {
      this.cppCoiRequestService.webOrderNumberAndSplitId = obj.coiorderNumber + '~' + 0 + '~' + tab + '~CPPLanding';
    }
    // this.cppCoiRequestService.coiOrderNumber = obj.coiOrderNumber;
    this.router.navigate(['/cpp/cpp-coi-request-confirmation']);
  }

  emailOrderDetail(obj: any) {
    let emailId = '';
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      var data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        emailId = data.resultData[0].emailId;
      }
    }

    this.tabNode = this.tabNode ? false : true;
    data = this.isSubscriptionAccess ? { title: 'Send Email', tabNode: this.tabNode, dialogType: 'nonSubscriberEmail' } : { email: emailId, title: 'Send Email', tabNode: this.tabNode, dialogType: 'email' };
    const emailDialog = this.matDialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '480px',
      data: data
    });
    this.subscription.add(emailDialog.afterClosed().subscribe(emailIds => {
      // If user selected Yes
      if (emailIds) {
        const data = {
          CoiorderNumber: obj.coiorderNumber,
          EmailIds: emailIds
        };
        this.loaderService.setLoaderStatus(true);
        this.subscription.add(this.cppCoiRequestService.sendCoiNewRequestEmail(data).subscribe(result => {
          if (result) { this.loaderService.setLoaderStatus(false); }
          this.toastrService.success('Email sent');
        }));
      }
      this.tabNode = false;
    }));
  }

  viewOrderToInvoice(element) {
    this.loaderService.setLoaderStatus(true);
    if (element.allJdeOrderNumbers && element.allJdeOrderNumbers != '' && element.allJdeOrderNumbers != '0') {
      //this.localStorageService.set(MasterConstants.OTI_SALESORDERNUMBER, element.allJdeOrderNumbers);
      //this.router.navigate(['/cc/landing-data']);
      this.filters.salesOrderNumber = element.allJdeOrderNumbers;
      this.filters.dateInDays = 0;
      this.filters.fromOrderDate = element.draftDate !== null ? new Date(element.draftDate) : null;
      this.filters.toOrderDate = new Date();
      this.filters.orderStatus = null;
      this.filters.orderStatusText = "ALL";
      this.filters.productLineSegment = 'CPP';
      this.filters.dateRangeText = this.filters.fromOrderDate != null && this.filters.toOrderDate != null ? this.datePipe.transform(this.filters.fromOrderDate, 'MM/dd/yyyy')
        + ' - ' + this.datePipe.transform(this.filters.toOrderDate, 'MM/dd/yyyy') : "";
      this.otiService.setFilters(this.filters);
      this.router.navigate(['/order/dashboard']);
    } else {
      this.toastrService.error('Order not found. Please check back.');
    }
    this.loaderService.setLoaderStatus(false);
  }

  // Generate PDF
  generatedPdf(order: any) {
    if (order.coiorderNumber) {
      this.cppCoiRequestService.generatePdf(order.coiorderNumber);
    }
  }

  public export() {
    this.loaderService.setLoaderStatus(true);

    this.subscription.add(this.cppCoiRequestService.getLandingExportData(this.filter).subscribe((result: any[]) => {
      this.loaderService.setLoaderStatus(true);
      if (this.selectedTabIndex === 0 && this.coiDataList && this.coiDataList.length > 0) {
        let coiExportDataList: any = [];
        // Active tab variables.
        coiExportDataList = result.filter(x => x.status !== 'DRAFT');
        var exportData = [];
        coiExportDataList.forEach(x => {
          exportData.push({
            'Request Id': x.coiorderNumber,
            'Customer PO#': x.custPONumber,
            'Account Name': x.accountName,
            'Account Number': x.accountNumber,
            'Request Date': this.datePipe.transform(x.orderDate, MasterConstants.DATE_MMDDYYYY),
            'Item Number': x.itemNumber,
            'Product': x.product,
            'Quantity': x.orderQty + ' ' + x.orderUOM,
            'Status': x.status
          });
        });
        this.excelService.exportAsExcelFile(exportData, 'ActiveCOIRequests');
      }
      else if (this.selectedTabIndex === 1 && this.draftCoiDataList && this.draftCoiDataList.length > 0) {
        let draftExportCoiDataList: any = [];
        // Draft tab variables.
        draftExportCoiDataList = result.filter(x => x.status === 'DRAFT');
        var exportData = [];
        this.loaderService.setLoaderStatus(true);
        draftExportCoiDataList.forEach(x => {
          exportData.push({
            'Request ID': x.coiorderNumber,
            'Customer PO#': x.custPONumber,
            'Account Name': x.accountName,
            'Account Number': x.accountNumber,
            'Draft Date': this.datePipe.transform(x.draftDate, MasterConstants.DATE_MMDDYYYY),
            'Item Number': x.itemNumber,
            'Product': x.product,
            'Quantity': x.orderQty + ' ' + x.orderUOM,
            'Status': x.status
          });
        });
        this.excelService.exportAsExcelFile(exportData, 'DraftsCOIRequests');
        this.loaderService.setLoaderStatus(false);
      }

      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }
}
